import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';

import { AppUtilityService } from 'src/app/app-utility.service';
import { PaySlipModel1 } from 'src/app/core/models/pay-slip.model';
import { NumbersOnlyDirective } from 'src/app/shared/directives';
import { LmsModalFrameComponent } from '@lmsSharedUI';
import { MdbDatepickerModule, MdbFormsModule, MdbModalRef } from 'src/lib/mdb5-adapted/public-api';

@Component({
  selector: 'app-payslip-dialog',
  templateUrl: './payslip-dialog.component.html',
  styleUrls: ['./payslip-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    //DatepickerModule,
    MdbDatepickerModule,
    NumbersOnlyDirective,
    MdbFormsModule,
    A11yModule,
    LmsModalFrameComponent
],
})
export class PayslipDialogComponent implements OnInit, AfterViewInit {
  PayDatesFilter = (d: Date): boolean => {
    const day = d.getDay();
    // Prevent Saturday and Sunday from being selected.
    return day !== 0 && day !== 6;
  };

  payslipModel: PaySlipModel1;
  payslipForm = this.fb.group({
      month: [0, [Validators.required]],
      payslipDate: [null as Date | null, [Validators.required]],
      grossIncome: [null as number | null, [Validators.required]],
      nettIncome: [null as number | null, [Validators.required]],
      otherIncome: [0, [Validators.min(0)]]
    });
  submitted = false;
  payDateError: string;
  invalidDate = false;
  maxDate = new Date();
  clientType = '';
  month: number;

  datePickerOptions = {
    format: 'yyyy-mm-dd',
    max: this.maxDate
  };

  constructor(
    public dialogRef: MdbModalRef<PayslipDialogComponent>,
    public global_utility: AppUtilityService,
    public fb: FormBuilder
  ) {}

  ngOnInit(): void {
    console.log(this.clientType);

    // Initialize payslipModel if it's null or undefined
    if (!this.payslipModel) {
      this.payslipModel = {} as PaySlipModel1;
    }

    this.payslipModel.month = this.month;

    // For SASSA and Pensioner clients, auto-populate gross income with nett income
    const isSassaOrPensioner = this.clientType === 'SASSA' || this.clientType === 'Pensioner';
    const initialGrossIncome = isSassaOrPensioner
      ? (this.payslipModel.nettIncome || this.payslipModel.grossIncome || null)
      : (this.payslipModel.grossIncome || null);

    const payslipDateValue = this.payslipModel.payslipDate || this.payslipModel.date;
    const initialPayslipDate = payslipDateValue ? new Date(payslipDateValue) : null;

    // Populate form with existing data if available
    if (this.payslipModel) {
      this.payslipForm.patchValue({
        month: this.payslipModel.month,
        payslipDate: payslipDateValue ? new Date(payslipDateValue) : null,
        grossIncome: initialGrossIncome,
        nettIncome: this.payslipModel.nettIncome,
        otherIncome: this.payslipModel.otherIncome || 0
      });
    }
    // For SASSA and Pensioner clients, auto-update gross income when nett income changes
    if (isSassaOrPensioner) {
      this.payslipForm.get('nettIncome')?.valueChanges.subscribe(value => {
        if (value !== null && value !== undefined) {
          this.payslipForm.get('grossIncome')?.setValue(value, { emitEvent: false });
        }
      });
    }
  }

  ngAfterViewInit() {}

  closeDialog() {
    this.dialogRef.close();
  }

  save() {
    this.submitted = true;

    if (this.payslipForm.invalid) {
      this.global_utility.warning('Please enter required payslip details','Income details');
      return;
    }

    const dateInput = this.payslipForm.value.payslipDate;
    const dateValue = typeof dateInput === 'string' ? new Date(dateInput) : (dateInput ?? new Date());
    this.payslipModel.date = dateValue;
    this.payslipModel.payslipDate = dateValue;
    this.payslipModel.grossIncome = this.payslipForm.value.grossIncome ?? 0;
    this.payslipModel.nettIncome = this.payslipForm.value.nettIncome ?? 0;
    this.payslipModel.otherIncome = this.payslipForm.value.otherIncome ?? 0;
    return this.dialogRef.close(this.payslipModel);
  }

  get payslipInput() {
    return this.payslipForm?.controls;
  }

  get payslipDate() {
    return this.payslipForm?.get('payslipDate');
  }

  get grossIncome() {
    return this.payslipForm?.get('grossIncome');
  }

  get nettIncome() {
    return this.payslipForm?.get('nettIncome');
  }

  get otherIncome() {
    return this.payslipForm?.get('otherIncome');
  }

}
